<template>
  <div
    class="img"
    :class="imgType === 'logo' ? 'logo-container' : 'fb fb-main-start fb-wrap'"
  >
    <div
      v-for="item in imgList"
      :key="item.id"
      class="img-item fb fb-cross-center"
    >
      <i
        v-if="!showOnly && imgType !== 'logo'"
        class="iconfont font-32 img-item-clear"
        @click="handlerToClearImg(item.id)"
        >&#xe720;</i
      >
      <span
        v-if="item.previewImgURL && imgType !== 'logo'"
        class="inline-block h-50 w-50 head-img bd-radio-4"
        :style="{
          'background-image': `url(${item.previewImgURL})`,
          'background-size': item.bgSize || 'auto 50px'
        }"
      ></span>
      <img
        v-if="item.previewImgURL"
        class="hidden-img bd-radio-4"
        :class="{ 'logo-img': imgType === 'logo' }"
        :src="item.previewImgURL"
        @click="handlerToPreviewImg"
      />
    </div>
    <div
      v-if="
        imgType !== 'logo' ? !showOnly && imgList.length < maxLength : !showOnly
      "
      class="img-upload bd-radio-4"
      :class="imgType !== 'logo' ? '' : 'logo-input'"
    >
      <span> <i class="iconfont font-80 c-C0C0C0">&#xe6fe;</i></span>
      <input
        type="file"
        accept=".jpg,.png"
        :multiple="multiple"
        @change="handlerToUploadImg"
      />
    </div>
  </div>
</template>

<script>
import { miniImageNew } from '@/utils/comUtils'

export default {
  name: 'commonUploadImg',
  components: {},
  props: {
    imgType: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 9
    },
    showOnly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    imgs: Array,
    minFileSize: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imgList: [],
      countImgId: 1,
      imgContainer: null,
      img: null,
      imgNaturalHeight: 0,
      imgNaturalWidth: 0
    }
  },
  computed: {},
  watch: {
    imgs(val) {
      this.init()
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.imgContainer && this.imgContainer.setAttribute('style', 'display:none')
  },
  destroyed() {},
  methods: {
    init() {
      if (this.showOnly) {
        this.imgList = this.imgs.map((item, index) => {
          return {
            id: index,
            previewImgURL: item
          }
        })
      } else {
        this.imgList = this.imgs
      }
      this.handlerLoadImage()
    },
    handlerLoadImage() {
      const _this = this
      this.imgList.forEach((img, i) => {
        const _img = new Image()
        let _bg = `50px auto`
        _img.src = _img.previewImgURL || ''
        _img.onload = () => {
          if (_img.naturalWidth >= _img.naturalHeight) {
            _bg = `auto 50px`
          }
          _this.$set(img, 'bgSize', _bg)
        }
      })
    },
    handlerToUploadImg(e) {
      if (this.showOnly) {
        return
      }
      let _files = e.target.files || e.dataTransfer.files
      if (!this.multiple && _files.length > 1) {
        this.$emit('error', new Error(`请上传单张图片`))
        return
      }
      if (this.imgType !== 'logo') {
        if (this.imgList.length + _files.length > this.maxLength) {
          this.$emit('error', new Error(`最多只能选择${this.maxLength}张照片`))
          return
        }
      } else {
        this.imgList = []
      }

      for (let _file of _files) {
        if (
          _file instanceof File &&
          (_file.type === 'image/png' ||
            _file.type === 'image/jpeg' ||
            _file.type === 'image/jpg')
        ) {
          miniImageNew(_file, 1024 * 1024 * 10, _file.type, 5 * 1024 * 1024)
            .then(result => {
              let _img = {
                id: `${Math.random()}`.replace('0.', 'img'),
                previewImgURL: result.base64,
                blob: result.blob,
                name: _file.name || ''
              }
              this.imgList.push(_img)
              this.$emit('change', this.imgList)
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          this.$emit('error', new Error(`只能上传图片`))
        }
      }
    },
    handlerToClearImg(imgId) {
      if (this.showOnly) {
        return
      }
      let _index = this.imgList.findIndex(item => {
        return item.id === imgId
      })
      this.imgList.splice(_index, 1)
      this.$emit('remove', _index)
    },
    handlerToPreviewImg(e) {
      if (this.imgType !== 'logo') {
        if (this.imgContainer) {
          // 元素存在时，更新图像URL
          if (this.img.src === e.target.src) {
            this.imgContainer.removeAttribute('style')
          } else {
            this.img.src = e.target.src
            this.img.onload = () => {
              // 获取图像真实宽高
              this.imgNaturalHeight = e.target.naturalHeight
              this.imgNaturalWidth = e.target.naturalWidth
              // 计算缩放后图像宽高
              this.methodCalcImgWidthAndHeight()
              this.imgContainer.removeAttribute('style')
            }
          }
          return
        }
        // 创建图像容器
        this.imgContainer = document.createElement('div')
        this.imgContainer.setAttribute(
          'class',
          'img-container fb fb-main-center fb-cross-center'
        )
        this.imgContainer.onclick = e => {
          this.imgContainer.setAttribute('style', 'display:none')
        }
        // 创建图像元素
        this.img = document.createElement('img')
        this.img.onclick = e => {
          this.imgContainer &&
            this.imgContainer.setAttribute('style', 'display:none')
        }

        // 获取图像真实宽高
        this.imgNaturalHeight = e.target.naturalHeight
        this.imgNaturalWidth = e.target.naturalWidth
        // 计算缩放后图像宽高
        this.methodCalcImgWidthAndHeight()
        // 加载图像
        this.img.src = e.target.src
        this.img.onload = () => {
          // 挂载
          this.imgContainer.appendChild(this.img)
          document.body.appendChild(this.imgContainer)
        }

        if (this.stop) {
          e.stopPropagation()
        }
      }
    },
    methodCalcImgWidthAndHeight() {
      // 获取浏览器窗口可见区域宽高
      let _baseHeight = window.innerHeight - 80
      let _baseWidth = window.innerWidth

      // 获取图像真实宽高
      let _imgHeight = this.imgNaturalHeight
      let _imgWidth = this.imgNaturalWidth
      let _height
      let _width
      let _baseSize = _baseHeight
      // 图像缩放
      if (_imgHeight > _imgWidth) {
        _height = _baseSize
        _width = _imgWidth * (_baseSize / _imgHeight)
      } else {
        _baseSize = _baseWidth
        _width = _baseSize
        _height = _imgHeight * (_baseSize / _imgWidth)
      }
      this.img &&
        this.img.setAttribute(
          'style',
          `height: ${_height}px; width: ${_width}px;`
        )
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.img {
  > div {
    width: 50px;
    height: 50px;
    margin-right: 15px;
    margin-bottom: 15px;
    background: #f6f6f6;

    &:first-child {
      margin-left: 0px;
    }

    &.img-item {
      position: relative;
      border-radius: 6px;

      > .img-item-clear {
        position: absolute;
        top: -10px;
        right: -10px;
        color: #a0a5ab;
      }
      > img {
        width: 100%;
        height: 100%;
      }
    }

    &.img-upload {
      position: relative;
      > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      > input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
    &.logo-input {
      width: 80px;
      height: 56px;
      background: transparent;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 99;
      span,
      input {
        opacity: 0;
      }
    }
  }
}
.logo-container {
  width: 40px;
  height: 36px;
  margin-right: 0;
  border-radius: 18px !important;
  overflow: hidden;
  > div {
    width: 36px;
    height: 36px;
    margin: 0;
    background: transparent;
    border-radius: 18px !important;
    overflow: hidden;
  }
}
.img-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(#000, 1);
  overflow: hidden;

  > img {
    box-shadow: 2px 2px 2px 0px rgba(#121d1e, 0.1);
  }
}
.head-img {
  background-repeat: no-repeat;
  background-position: center center;
  width: 50px;
}
.logo-img {
  top: 0;
  right: 0;
  position: absolute;
  width: 36px !important;
  height: 36px !important;
  border-radius: 18px !important;
  overflow: hidden;
  background-size: 36px 36px;
}

.hidden-img {
  position: absolute;
  opacity: 0;
}
</style>
